module.exports = __webpack_public_path__ + "MR.png?b2b167b562567f5a12172d2f214bab85";